import {
  propertyClassificationsService,
  type PropertyClassification,
} from '@/services/property-classifications';
import { useQuery } from '@tanstack/react-query';

type UsePropertyClassificationsParams = {
  enabled?: boolean;
};

export function usePropertyClassifications({
  enabled = true,
}: UsePropertyClassificationsParams = {}) {
  return useQuery<PropertyClassification[], Error>({
    queryKey: ['property-classifications'],
    queryFn: async () => {
      const response =
        await propertyClassificationsService.getPropertyClassifications();

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar classificações do imóvel'
        );
      }

      return response.data.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
